export default __webpack_public_path__ + "media/flags/il-b15ab0fb.svg";